import shouldTrackEventDefault from './shouldTrackEvent';
import withAdContextData from './withAdContextData';
import { log, logEvent } from '../utils/loggingUtil';

export function track(
  withEventData,
  adSpot,
  shouldTrackEvent = shouldTrackEventDefault,
) {
  try {
    const eventData = withEventData(adSpot);

    if (!eventData) {
      return;
    }

    const context = withAdContextData(adSpot);
    logEvent(eventData, context);

    const { tracking } = adSpot;

    if (shouldTrackEvent(tracking)) {
      tracking.trackEvent(eventData, context);

      log('Event tracked');
    }
  } catch (error) {
    console.error(error);
  }
}
